import React from "react";
import { Box, Button, Paper, Typography, Alert } from "@mui/material";
import { CloudUpload as UploadIcon } from "@mui/icons-material";

const UploadStep = ({
  fileLabel,
  fileInputRef,
  onFileChange,
  onDrop,
  preventDefault,
  errorMsg,
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 2, sm: 3 },
        mb: { xs: 2, sm: 3 },
        borderRadius: 2,
        border: "1px dashed #c7c7c7",
        backgroundColor: "#fff",
        textAlign: "center",
      }}
      onDrop={onDrop}
      onDragOver={preventDefault}
      onDragEnter={preventDefault}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 1,
        }}
      >
        <UploadIcon
          sx={{ color: "#6b7280", fontSize: { xs: "2.6rem", sm: "3.2rem" } }}
        />
      </Box>

      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          fontSize: { xs: "1.2rem", sm: "1.6rem" },
          textAlign: "center",
        }}
      >
        Upload File
      </Typography>

      {errorMsg ? (
        <Alert
          severity="error"
          sx={{
            my: 1.5,
            textAlign: "left",
            fontSize: { xs: "1.1rem", sm: "1.2rem" },
          }}
        >
          {errorMsg}
        </Alert>
      ) : (
        <Alert
          severity="info"
          sx={{
            my: 1.5,
            textAlign: "left",
            fontSize: { xs: "1.1rem", sm: "1.2rem" },
          }}
        >
          Imported file must be a CSV consisting of a single column (or
          comma-delimited list) of numeric address numbers indicating customers.
          The column/list should not have a header.
        </Alert>
      )}

      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mb: 2,
          fontSize: { xs: "1.1rem", sm: "1.2rem" },
        }}
      >
        {fileLabel}
      </Typography>

      <Button
        variant="outlined"
        component="label"
        startIcon={<UploadIcon />}
        size="small"
        sx={{
          fontSize: { xs: "1.1rem", sm: "1.2rem" },
          width: { xs: "100%", sm: "auto" },
        }}
      >
        Browse
        <input
          type="file"
          accept=".csv"
          hidden
          onChange={onFileChange}
          ref={fileInputRef}
        />
      </Button>
    </Paper>
  );
};

export default UploadStep;
